import { create } from 'zustand';
import { apiClient } from '@core/api';

export const useMenuStore = create((set) => ({
  vegMasterId: '',
  nonVegMasterId: '',
  fetchMasters: async () => {
    try {
      const response = await apiClient.get('/masters', {
        query: { limit: 100 },
      });
      const data = response?.data;

      if (data && data['food-indicator']) {
        const indicators = data['food-indicator'];

        const vegObj = indicators.find((item) => item.slug === 'veg');
        const nonVegObj = indicators.find((item) => item.slug === 'nonveg');
        set({
          vegMasterId: vegObj?.master_id,
          nonVegMasterId: nonVegObj?.master_id,
        });
      }
    } catch (error) {
      console.error('Failed to fetch food indicator masters:', error);
    }
  },
}));
